import type { MissionDef } from '../core/game/mission-director.js';
import { ITEMS } from '../content/icons.js';
import { RECIPES } from '../core/world/route-gen.js';

/**
 * The mission pool: one thing to fetch, crossed with one kind of place to fetch it from.
 *
 * Every item paired with every recipe, which is a hundred-odd missions rather than a dozen - and because
 * each one generates its ground from a fresh seed, no two are the same drive even when they are the same
 * pairing. The unlock requirement is carried through from the recipe; none of them gate anything now that
 * every prize is a hat, and the ground's difficulty comes from how many missions she has finished instead.
 *
 * Still assembled in code rather than loaded from the content pack manifest. That is the next thing to move
 * out, but it is not what makes a route interesting.
 */
export const MISSIONS: readonly MissionDef[] = RECIPES.flatMap((recipe) =>
  ITEMS.map((item) => ({
    id: `m-${item.id}-${recipe.id}`,
    itemId: item.id,
    recipeId: recipe.id,
    requiredUnlock: recipe.requiredUnlock,
    rewardPoints: 10,
  })),
);

export function missionFor(missionId: string | null): MissionDef | null {
  if (missionId === null) return null;
  return MISSIONS.find((mission) => mission.id === missionId) ?? null;
}
